module.exports = __webpack_public_path__ + "img/1499532263.af2b19c6.jpg";